import * as Sentry from '@sentry/browser'

/**
 * Reports subpar performance
 * @param {string} url
 * @param {number} perf
 */
export function captureMiddlewarePerformance(url, perf) {
  const perfThreshold = 5000
  if (perf < perfThreshold) {
    return
  }

  const event = `middleware-performance-above-${perfThreshold}`
  const performance = `${perf.toFixed(2)}ms`

  const name = `${event}@${url}`

  Sentry.captureMessage(name, (scope) => {
    scope.setTransactionName(name)

    scope.setFingerprint([name])

    scope.setTags({
      metric: 'middleware-performance',
    })

    scope.setExtras({
      performance,
    })

    return scope
  })
}
